import {useStaticQuery, graphql} from "gatsby"

const useTeamQuery = () => {
  const {allDatoCmsTeamMember, allDatoCmsServicesTag, allDatoCmsLocation} = useStaticQuery(graphql`
      query Team {
        allDatoCmsServicesTag(
          sort: {title: ASC}
        ) {
          nodes {
            title
          }
        }
        allDatoCmsLocation(
          sort: {position: ASC}
        ) {
          nodes {
            title
          }
        }
        allDatoCmsTeamMember(
          sort: {position: ASC}
        ) {
          nodes {
            jobTitle
            linkedin
            slug
            title
            permalink
            bio {
              value
            }
            thumbnail {
              ...InternalAssetProps
            }
            services {
              title
            }
            locations {
              title
            }
          }
        }
      }
`)

  return {allDatoCmsTeamMember, allDatoCmsServicesTag, allDatoCmsLocation}
}

export default useTeamQuery